// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1oNn4","label":"styles_label__1UMwp","text":"styles_text__3Xiny"};